import React from 'react';
import { StatusBadge, StatusType } from 'components/StatusBadge/StatusBadge';
import './NumberedHistoryCard.scss';

export type NumberedHistoryCardProps = {
    number: number;
    title: string;
    subtitle: string;
    status?: StatusType;
    selected?: boolean;
    onClick: () => void;
};

export const NumberedHistoryCard: React.FC<NumberedHistoryCardProps> = ({
    number,
    title,
    subtitle,
    status,
    selected = false,
    onClick
}) => {
    return (
        <button
            type="button"
            className={`numbered-history-card ${selected ? 'numbered-history-card--selected' : ''}`}
            onClick={onClick}
            aria-pressed={selected}
        >
            <span className="numbered-history-card__number">{number}</span>
            <span className="numbered-history-card__content">
                <span className="numbered-history-card__title">{title}</span>
                <span className="numbered-history-card__subtitle">{subtitle}</span>
                {status && status !== 'accepted' && <StatusBadge status={status} />}
            </span>
            {selected && <span className="numbered-history-card__arrow" aria-hidden="true">▶</span>}
        </button>
    );
};
